module.exports = __webpack_public_path__ + "3b43e8521b44ea05b00e3ed377596193.pdf";